import { runInAction } from 'mobx';
import { LoadingState } from '../../types/loading-state';
import { createFetchedData } from './create-fetched-data';
/**
 * Creates a new FetchedData object with the initial "not loaded" state,
 * or returns the existing state if it has already been created.
 *
 * @param record The FetchedDataRecord that the state is being added to.
 * @param id The key/ID of the new FetchedData state.
 */
export const createOrGetFetchedState = (record, id) => {
    // State already exist, no need to create it.
    if (record[id])
        return record[id];
    runInAction(() => {
        record[id] = createFetchedData(LoadingState.NotLoaded);
    });
    return record[id];
};
